export default __webpack_public_path__ + "static/media/plus.81d38a34.svg";